import {
  Button,
  Card,
  Col,
  Input,
  message,
  Modal,
  Popconfirm,
  Row,
  Skeleton,
  Typography,
} from "antd";
import React, { useEffect, useState } from "react";
import Post from "../services/Post";
import Get from "../services/Get";
import {
  CarFilled,
  DotChartOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import Meta from "antd/lib/card/Meta";
import TwoWheeler from "../assets/images/two-wheeler.png";

const AddVehicle = () => {
  const [vehicle, setVehicle] = useState();
  const [alreadyVehicles, setAlreadyVehicles] = useState([]);
  const [loading, setLoading] = useState();
  const [messages, setMessages] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const getVehicle = async () => {
    setLoading(true);
    try {
      const res = await Get.MyVehicle();
      setAlreadyVehicles(res.data);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = () => {
    if (!vehicle) {
      message.error("Please Enter Vehicle Number");
      return;
    }
    setLoading(true);

    Post.AddVehicle({ number: vehicle }).then((res) => {
      setLoading(false);
      if (res.success) {
        getVehicle();
        message.success(res.success);
      } else if (res.errorMsg) {
        message.error(res.errorMsg);
      } else if (res.error) {
        message.error(res.error);
      }
    });
  };

  const removeVehicle = (id) => {
    setLoading(true);
    Post.DeleteVehicle(id).then((res) => {
      setLoading(false);
      if (res.success) {
        getVehicle();
        message.success(res.success);
      } else if (res.error) {
        message.error(res.error);
      }
    });
  };

  const viewMessages = async (vehicleId) => {
    setLoading(true);
    try {
      const res = await Get.VehicleMessages(vehicleId);
      setMessages(res.data);
      setIsModalVisible(true);
    } catch (error) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getVehicle();
  }, []);

  return (
    <div>
      <Row justify={"center"}>
        <Col xs={24} xl={8} md={12}>
          <Typography.Title level={2}>Add New Vehicle</Typography.Title>
          <Card style={{ padding: 10 }}>
            <Typography.Title level={5}>Enter Vehicle Number</Typography.Title>
            <Input
              placeholder="Enter Vehicle Number"
              type="text"
              onChange={(e) => setVehicle(e.target.value)}
              style={{ marginBottom: 30 }}
            />
            <Button
              type="primary"
              block
              onClick={handleSubmit}
              className="form-btn"
            >
              Submit
            </Button>
          </Card>
        </Col>
      </Row>

      <div style={{ marginTop: 40 }}>
        <Typography.Title level={2}>My Vehicles</Typography.Title>
        {loading ? (
          <Skeleton active />
        ) : (
          <Row gutter={[16, 24]} justify="center">
            {alreadyVehicles.length > 0 ? (
              alreadyVehicles.map((Item) => (
                <Col md={12} lg={6} xs={24} key={Item.id}>
                  <Card
                    hoverable
                    cover={
                      Item.vehicle_seat_capacity > 2 ? (
                        <CarFilled
                          style={{ fontSize: "150px", padding: "40px 0" }}
                        />
                      ) : (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            padding: "40px 0",
                          }}
                        >
                          <img
                            style={{ width: "150px" }}
                            src={TwoWheeler}
                            alt="Two Wheeler"
                          />
                        </div>
                      )
                    }
                    extra={[
                      <Button
                        onClick={() => viewMessages(Item?.reg_no)}
                        className="form-btn"
                      >
                        View Messages
                      </Button>,
                      <Popconfirm
                        title="Are you sure to remove this vehicle?"
                        onConfirm={() => removeVehicle(Item.id)}
                        okText="Remove"
                        okButtonProps={{
                          style: { backgroundColor: "red", borderColor: "red" },
                        }}
                        cancelText="Cancel"
                        icon={
                          <QuestionCircleOutlined style={{ color: "red" }} />
                        }
                      >
                        <Button type="text" danger>
                          Remove
                        </Button>
                      </Popconfirm>,
                    ]}
                  >
                    <Meta title={Item?.model} description={Item?.reg_no} />
                  </Card>
                </Col>
              ))
            ) : (
              <Typography.Text>You have no vehicle!</Typography.Text>
            )}
          </Row>
        )}
      </div>

      <Modal
        title="Vehicle Messages"
        open={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        {messages.length > 0 ? (
          <ul>
            {messages.map((msg, index) => (
              <li key={index}>{msg.message}</li>
            ))}
          </ul>
        ) : (
          <Typography.Text>No messages found.</Typography.Text>
        )}
      </Modal>
    </div>
  );
};

export default AddVehicle;
